"use client";

import * as React from "react";
import { cn } from "../lib";
import { IntentProgressBar } from "./intent-ui/progress-bar";

const Progress = ({
	className,
	value,
	...props
}: React.HTMLAttributes<HTMLDivElement> & { value?: number | null }) => {
	return (
		<IntentProgressBar
			value={value}
			className={cn("h-4 w-full", className)}
			trackClassName="h-4 w-full bg-border"
			indicatorClassName="bg-primary"
			{...props}
		/>
	);
};

export { Progress };
